import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminAuthGuard} from '../../core/auth/service/guards/admin-auth.guard';
import {MaterialModule} from '../../core/material/material.module';
import {CoreModule} from '../../core/core.module';
import {RouterModule} from '@angular/router';
import {GameControlsService} from '../../core/services/gamecontrols/gamecontrols.service';
import {ReviewService} from '../../core/services/review/review.service';
import {OrganizationGuard} from '../../core/services/organization/guards/organization.guard';
import {VideoControlComponent} from './video-control.component';
import {BonusComponent} from './bonus/bonus.component';
import {MalusComponent} from './malus/malus.component';
import {ShowtimeControlsComponent} from './showtime-controls/showtime-controls.component';
import {LivePreviewWidgetComponent} from './live-preview-widget/live-preview-widget.component';

const routes = [
    {path: 'org/:organization/video-control', component: VideoControlComponent, canActivate: [OrganizationGuard, AdminAuthGuard]},
    {path: 'org/:organization/game/bonus', component: BonusComponent, canActivate: [OrganizationGuard, AdminAuthGuard]},
    {path: 'org/:organization/game/malus', component: MalusComponent, canActivate: [OrganizationGuard, AdminAuthGuard]}
];

@NgModule({
    imports: [
        MaterialModule,
        CommonModule,
        CoreModule,
        RouterModule.forChild(routes),
    ],
    declarations: [
        VideoControlComponent,
        BonusComponent,
        MalusComponent,
        ShowtimeControlsComponent,
        LivePreviewWidgetComponent
    ],
    providers: [
        GameControlsService,
        ReviewService
    ]
})
export class VideoControlModule {
}
